export default "__VITE_ASSET__DLbF$3$f__"